// components/CustomerInfo.tsx
import React from "react";
import LabelValueRow from "./LabelValueRow";
import { formatDate } from "src/shared/components/dateUtils";
import { Order } from "src/shared/services/interfacev2";

interface CustomerInfoProps {
  orderData: Order;
  orderId: string | null;
}

const CustomerInfo: React.FC<CustomerInfoProps> = ({ orderData, orderId }) => {
  const customer = orderData.customerDetails;

  // Safely get customer name with fallback
  const customerName = customer 
    ? `${customer.firstName || ""} ${customer.lastName || ""}`.trim()
    : "N/A";

  // Safely get phone with fallback
  const phone = customer?.phones?.[0]?.phone ?? "N/A";

  const displayOrderId = orderData.orderId || orderId || "N/A";

  const orderDate = orderData.orders?.[0]?.orderedOn?.$date ?? orderData.orders?.[0]?.createdOn?.$date ?? null;

  const paymentMethod = orderData.paymentHistory?.[0]?.paymentMethod ?? "N/A";

  return (
    <>
      <div className="flex justify-between mb-2">
        <LabelValueRow label="Date:" value={orderDate ? formatDate(orderDate) : "N/A"} />
        <LabelValueRow label="Order ID:" value={displayOrderId} />
      </div>

      <div className="border-y border-dashed border-black py-2 mb-3">
        <LabelValueRow label="Customer:" value={customerName} />
        <LabelValueRow label="Phone:" value={phone} />
        <LabelValueRow label="Payment:" value={paymentMethod} />
      </div>
    </>
  );
};

export default CustomerInfo;